import { render, staticRenderFns } from "./ZzfBoard.vue?vue&type=template&id=6f335570&scoped=true&"
import script from "./ZzfBoard.vue?vue&type=script&lang=js&"
export * from "./ZzfBoard.vue?vue&type=script&lang=js&"
import style0 from "./ZzfBoard.vue?vue&type=style&index=0&id=6f335570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f335570",
  null
  
)

export default component.exports